interface LogoProps {
  /** Só o símbolo, sem o nome */
  markOnly?: boolean
  className?: string
}

/** Símbolo do FinControl: três barras crescentes sobre o verde pinho. */
export function LogoMark({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 26 26" aria-hidden="true" className="shrink-0">
      <rect width="26" height="26" rx="6" fill="#085A42" />
      <rect x="6" y="14" width="3.2" height="6" rx="1" fill="#D5EBE0" />
      <rect x="11.4" y="10" width="3.2" height="10" rx="1" fill="#D5EBE0" />
      <rect x="16.8" y="6" width="3.2" height="14" rx="1" fill="#FFFFFF" />
    </svg>
  )
}

export function Logo({ markOnly = false, className = "" }: LogoProps) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <LogoMark />
      {!markOnly && <span className="font-semibold tracking-[-0.01em] text-[16px] text-foreground">FinControl</span>}
    </span>
  )
}
